import { createApp } from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import api, { setLogoutFunction } from '@/api/axios';
import firebaseApp from './firebase'; // Ensure you’ve initialized Firebase here
import { getAuth, signOut } from 'firebase/auth';

// Library Components
import VueSweetalert2 from 'vue-sweetalert2';
import VueApexCharts from 'vue3-apexcharts';
import BootstrapVue3 from 'bootstrap-vue-3';
import CounterUp from 'vue3-autocounter';
import 'aos/dist/aos.css';

// Custom Components & Directives
import globalComponent from './plugins/global-components';
import globalDirective from './plugins/global-directive';
import globalMixin from './plugins/global-mixin';

//Toast integration
import Toast from 'vue3-toastify';
import 'vue3-toastify/dist/index.css'; // Import the toastify styles

require('waypoints/lib/noframework.waypoints.min');

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';

// Add icons to the library
library.add(fas);

// Initialize Firebase Auth globally
const auth = getAuth(firebaseApp);

const app = createApp(App);

// Make the Axios instance available globally as $api
app.config.globalProperties.$api = api;

// Make the Vuex store instance available globally as $store
app.config.globalProperties.$store = store;

// Add Firebase to app's global properties for access in all components
app.config.globalProperties.$auth = auth;

app.config.globalProperties.$logout = async () => {
  try {
    // Sign out from Firebase
    await signOut(auth);

    // Call the Vuex action to clear both global state and auth state
    await app.config.globalProperties.$store.dispatch('clearState');

    // Clear sensitive data from localStorage and sessionStorage, but preserve MFA prompt flags
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      // Keep MFA prompt flags (they start with 'mfa_prompt_shown_')
      if (!key.startsWith('mfa_prompt_shown_')) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach(key => localStorage.removeItem(key));
    sessionStorage.clear();

    // Redirect to login page
    app.config.globalProperties.$router.push('/auth/login');

    console.log('User logged out successfully');
  } catch (error) {
    console.error('Logout failed:', error);
    alert('An error occurred during logout. Please try again.');
  }
};

setLogoutFunction(app.config.globalProperties.$logout);

app.use(store).use(router);
app.use(Toast); // Add Toast to the app
// Register the FontAwesomeIcon component globally
app.component('font-awesome-icon', FontAwesomeIcon);

// Library Components
app.use(VueSweetalert2);
app.use(VueApexCharts);
app.use(BootstrapVue3);
app.component('counter-up', CounterUp);

// Custom Components & Directives
app.use(globalComponent);
app.use(globalDirective);
app.mixin(globalMixin);

app.mount('#app');

export default app;
